import React from 'react';
import VoiceoverContext from '../VoiceoverContext';

export default function VoiceoverProvider(props) {
  const { value, children } = props;
  return <VoiceoverContext.Provider value={value}>{children}</VoiceoverContext.Provider>;
}
